import Vue from 'vue';

export default {
  setVariable(state, {key, value}) {
    Vue.set(state, key, value);
  },

  pushVariables(state, {key, value}) {
    state[key].push(value);
  },

  appendPosts(state, data) {
    if (data && data.length) {
      state.posts.push(...data);
    }
  },
};
